import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-0cbae102")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 新建數據 ")
const _hoisted_3 = { class: "handler-btns" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 修改 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 刪除 ")
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_BaseTable = _resolveComponent("BaseTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseTable, _mergeProps(_ctx.contentConfig, {
      list: _ctx.datalist,
      listCount: _ctx.totalCount,
      page: _ctx.page,
      "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => (_ctx.page = $event))
    }), _createSlots({
      headerHandler: _withCtx(() => [
        (_ctx.isCreate)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              size: "medium",
              onClick: _ctx.handleNewClick
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      status: _withCtx((scope) => [
        _createVNode(_component_el_button, {
          plain: "",
          size: "mini",
          type: scope.row.enable ? 'success' : 'danger'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(scope.row.enable ? '啟用' : '禁用'), 1)
          ]),
          _: 2
        }, 1032, ["type"])
      ]),
      createAt: _withCtx((scope) => [
        _createTextVNode(_toDisplayString(_ctx.$filter.formateTime(scope.row.createAt)), 1)
      ]),
      updateAt: _withCtx((scope) => [
        _createTextVNode(_toDisplayString(_ctx.$filter.formateTime(scope.row.updateAt)), 1)
      ]),
      handler: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isUpdate)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                icon: "el-icon-edit",
                size: "mini",
                type: "text",
                onClick: ($event: any) => (_ctx.handleEditClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          (_ctx.isDelete)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                icon: "el-icon-delete",
                size: "mini",
                type: "text",
                onClick: ($event: any) => (_ctx.handleDeleteClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      _renderList(_ctx.otherSlotProps, (item) => {
        return {
          name: item.slotName,
          fn: _withCtx((scope) => [
            _renderSlot(_ctx.$slots, item.slotName, {
              row: scope.row
            }, undefined, true)
          ])
        }
      })
    ]), 1040, ["list", "listCount", "page"])
  ]))
}